import { Row, Col } from "react-bootstrap";
import "../common.css";
import { useNavigate } from "react-router-dom";

function Footer({ actions }) {
  const navigate = useNavigate();
  return (
    <Row className="mt-5 mb-5">
      <Col
        xs={{ span: 10, offset: 1 }}
        sm={{ span: 8, offset: 2 }}
        md={{ span: 6, offset: 3 }}
      >
        {actions && <div className="centered-container mb-4">{actions}</div>}
        <div className="home-breadcrumb">
          <span onClick={() => navigate("/")}>Back to All Lists</span>
        </div>
      </Col>
    </Row>
  );
}

export default Footer;
